const inFlightControllers = new Map();

export function isRequestCancelled(error) {
  if (!error) return false;
  if (error.cancelled === true) return true;
  if (error?.code === 'ERR_CANCELED') return true;
  if (error?.name === 'AbortError') return true;
  return error?.message === 'canceled';
}

export function abortRequest(cancelKey) {
  if (!cancelKey) return;
  const existing = inFlightControllers.get(cancelKey);
  if (existing) {
    existing.abort();
    inFlightControllers.delete(cancelKey);
  }
}

export function abortRequestsByPrefix(prefix) {
  if (!prefix) return;
  for (const key of [...inFlightControllers.keys()]) {
    if (key.startsWith(prefix)) {
      abortRequest(key);
    }
  }
}

export function acquireCancelSignal(cancelKey) {
  abortRequest(cancelKey);
  const controller = new AbortController();
  inFlightControllers.set(cancelKey, controller);
  return controller;
}

export function releaseCancelSignal(cancelKey, controller) {
  if (inFlightControllers.get(cancelKey) === controller) {
    inFlightControllers.delete(cancelKey);
  }
}
